import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type Owner from '@ember/owner';
import { createStringStorage } from '../utils/local-storage';

export default class Language extends Service {
  @tracked preferredLanguage: string = 'en';

  private languageStorage: ReturnType<typeof createStringStorage>;

  readonly languageOptions: { code: string; label: string }[] = [
    { code: 'en', label: 'English' },
  ];

  constructor(owner: Owner) {
    super(owner);
    this.languageStorage = createStringStorage('content-language');
    this.loadLanguage();
  }

  loadLanguage() {
    const saved = this.languageStorage.get();
    const valid = this.languageOptions.some((o) => o.code === saved);
    if (saved && valid) {
      this.preferredLanguage = saved;
    }
  }

  setLanguage(code: string) {
    if (this.languageOptions.some((o) => o.code === code)) {
      this.preferredLanguage = code;
      this.languageStorage.set(code);
    }
  }

  get currentLanguageLabel(): string {
    return (
      this.languageOptions.find((o) => o.code === this.preferredLanguage)
        ?.label ?? this.preferredLanguage
    );
  }
}

declare module '@ember/service' {
  interface Registry {
    language: Language;
  }
}
